
import { defineComponent } from "vue";
import { RegistrationIllustration } from "@pictograms";
import InlineSvg from "vue-inline-svg";

export default defineComponent({
  name: "CiInformationContent",
  components: {
    "inline-svg": InlineSvg,
  },
  props: {
    inModalContext: { type: Boolean, default: false },
  },
  setup() {
    const illustration: ImportedSVG = RegistrationIllustration;

    return { illustration };
  },
});
